'use strict';

var tslib_es6 = require('./tslib.es6-130a177d.js');
var React = require('react');
var styled = require('styled-components');
var viewport_utils = require('./viewport.utils-0c2b4e2b.js');
var Icons_ArrowIcon_index = require('./Icons/ArrowIcon/index.js');
var FloatingLabel_styles = require('./FloatingLabel.styles-a6386d0a.js');
var ReactDOM = require('react-dom');
var useOutsideClick = require('./useOutsideClick-531afbb5.js');
var useForceUpdateRef = require('./useForceUpdateRef-6d1ca28f.js');
var typography_index = require('./typography/index.js');
var scroll = require('./scroll-10f2cb64.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);
var ReactDOM__default = /*#__PURE__*/_interopDefaultLegacy(ReactDOM);

var MIN_ITEM_SCROLLABLE = 6;

var StyledWrapper = styled__default['default'].div.withConfig({ displayName: "ww-uikit_StyledWrapper_loy4z640", componentId: "sc-fjjh0m" })(templateObject_2 || (templateObject_2 = tslib_es6.__makeTemplateObject(["\n    ", "\n    position: relative;\n    width: 100%;\n    min-width: 75px;\n    display: flex;\n    flex-flow: column;\n    gap: 5px;\n    ", "\n"], ["\n    ", "\n    position: relative;\n    width: 100%;\n    min-width: 75px;\n    display: flex;\n    flex-flow: column;\n    gap: 5px;\n    ",
    "\n"])), typography_index.inputBaseCss, function (_a) {
    var isDisabled = _a.isDisabled;
    return isDisabled && styled.css(templateObject_1 || (templateObject_1 = tslib_es6.__makeTemplateObject(["\n            background: ", ";\n            opacity: 0.4;\n        "], ["\n            background: ", ";\n            opacity: 0.4;\n        "])), function (_a) {
        var theme = _a.theme;
        return theme.colors.charcoal3;
    });
});
var StyledSelect = styled__default['default'].select.withConfig({ displayName: "ww-uikit_StyledSelect_loy4z641", componentId: "sc-1maffsf" })(templateObject_4 || (templateObject_4 = tslib_es6.__makeTemplateObject(["\n    color: ", ";\n    opacity: 0;\n    position: absolute;\n    width: 100%;\n    height: 52px;\n    top: 0;\n    left: 0;\n    &:hover {\n        cursor: pointer;\n    }\n\n    ", "\n"], ["\n    color: ", ";\n    opacity: 0;\n    position: absolute;\n    width: 100%;\n    height: 52px;\n    top: 0;\n    left: 0;\n    &:hover {\n        cursor: pointer;\n    }\n\n    ",
    "\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.charcoal100;
}, viewport_utils.forDesktop(templateObject_3 || (templateObject_3 = tslib_es6.__makeTemplateObject(["\n        opacity: 0;\n    "], ["\n        opacity: 0;\n    "]))));
var StyledValidation = styled__default['default'].div.withConfig({ displayName: "ww-uikit_StyledValidation_loy4z641", componentId: "sc-7iv7qc" })(templateObject_5 || (templateObject_5 = tslib_es6.__makeTemplateObject(["\n    background-color: transparent;\n    background-color: ", ";\n    transition: all 0.2s ease-out;\n    display: block;\n    position: absolute;\n    left: -1px;\n    right: -1px;\n    bottom: -1px;\n    height: 2px;\n"], ["\n    background-color: transparent;\n    background-color: ",
    ";\n    transition: all 0.2s ease-out;\n    display: block;\n    position: absolute;\n    left: -1px;\n    right: -1px;\n    bottom: -1px;\n    height: 2px;\n"])), function (_a) {
    var theme = _a.theme, isValid = _a.isValid;
    if (isValid === undefined || isValid === null) {
        return 'transparent';
    }
    return isValid ? theme.colors.iconSuccess : theme.colors.iconCritical;
});
var StyledLabelContainer = styled__default['default'](FloatingLabel_styles.StyledInputWrapper).withConfig({ displayName: "ww-uikit_StyledLabelContainer_loy4z641", componentId: "sc-514gax" })(templateObject_6 || (templateObject_6 = tslib_es6.__makeTemplateObject(["\n    display: flex;\n    align-items: center;\n    justify-content: ", ";\n\n    padding: 0;\n"], ["\n    display: flex;\n    align-items: center;\n    justify-content: ", ";\n\n    padding: 0;\n"])), function (_a) {
    var isEmpty = _a.isEmpty;
    return (isEmpty ? 'right' : 'space-between');
});
var Trigger = styled__default['default'].div.withConfig({ displayName: "ww-uikit_Trigger_loy4z641", componentId: "sc-vqbhkq" })(templateObject_7 || (templateObject_7 = tslib_es6.__makeTemplateObject(["\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    align-self: flex-end;\n    height: 50px;\n    width: 50px;\n"], ["\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    align-self: flex-end;\n    height: 50px;\n    width: 50px;\n"])));
var DropdownBasicItem = styled__default['default'].div.withConfig({ displayName: "ww-uikit_DropdownBasicItem_loy4z641", componentId: "sc-1ts92pr" })(templateObject_8 || (templateObject_8 = tslib_es6.__makeTemplateObject(["\n    ", "\n    display: flex;\n    align-items: center;\n    height: 46px;\n    box-sizing: border-box;\n    padding: 0 16px;\n    color: ", ";\n    background: ", ";\n    width: 100%;\n    margin-bottom: -3px;\n\n    &[role='option']:hover {\n        background: ", ";\n        cursor: pointer;\n    }\n"], ["\n    ", "\n    display: flex;\n    align-items: center;\n    height: 46px;\n    box-sizing: border-box;\n    padding: 0 16px;\n    color: ", ";\n    background: ", ";\n    width: 100%;\n    margin-bottom: -3px;\n\n    &[role='option']:hover {\n        background: ", ";\n        cursor: pointer;\n    }\n"])), typography_index.inputBaseCss, function (_a) {
    var disabled = _a.disabled, theme = _a.theme;
    return (disabled ? theme.colors.charcoal20 : theme.colors.charcoal100);
}, function (_a) {
    var selected = _a.selected, theme = _a.theme;
    return (selected ? theme.colors.charcoal10 : '');
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.charcoal3;
});
styled__default['default'](DropdownBasicItem).withConfig({ displayName: "ww-uikit_DropdownSmallItem_loy4z641", componentId: "sc-kf7n7s" })(templateObject_9 || (templateObject_9 = tslib_es6.__makeTemplateObject(["\n    height: 30px;\n"], ["\n    height: 30px;\n"])));
var DropdownWrapper = styled__default['default'].div.withConfig({ displayName: "ww-uikit_DropdownWrapper_loy4z641", componentId: "sc-10knq9y" })(templateObject_11 || (templateObject_11 = tslib_es6.__makeTemplateObject(["\n    position: absolute;\n    z-index: ", ";\n    display: none;\n    ", "\n"], ["\n    position: absolute;\n    z-index: ", ";\n    display: none;\n    ",
    "\n"])), function (_a) {
    var theme = _a.theme;
    return theme.zIndexDesktopDropDown;
}, viewport_utils.forDesktop(templateObject_10 || (templateObject_10 = tslib_es6.__makeTemplateObject(["\n        display: block;\n    "], ["\n        display: block;\n    "]))));
var Dropdown = styled__default['default'].div.withConfig({ displayName: "ww-uikit_Dropdown_loy4z641", componentId: "sc-kd9ekc" })(templateObject_13 || (templateObject_13 = tslib_es6.__makeTemplateObject(["\n    display: none;\n    ", "\n\n    display: block;\n    border: solid 1px ", ";\n    border-top-style: none;\n    background: ", ";\n"], ["\n    display: none;\n    ",
    "\n\n    display: block;\n    border: solid 1px ", ";\n    border-top-style: none;\n    background: ", ";\n"])), function (_a) {
    var scrollable = _a.scrollable;
    return scrollable
        ? styled.css(templateObject_12 || (templateObject_12 = tslib_es6.__makeTemplateObject(["\n                  max-height: 264px;\n                  ", "\n              "], ["\n                  max-height: 264px;\n                  ", "\n              "])), scroll.scroll('y')) : '';
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.charcoal20;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.white;
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13;

var DropdownOptionList = function (_a) {
    var _b = _a.name, name = _b === void 0 ? '' : _b, children = _a.children, optionLength = _a.optionLength, containerRef = _a.containerRef, hideDropDown = _a.hideDropDown;
    var _c = useForceUpdateRef.useForceUpdateRef(), element = _c[0], setElement = _c[1];
    var _d = React.useState({ width: 0, top: 0, left: 0 }), environment = _d[0], setEnvironment = _d[1];
    React.useEffect(function () {
        var newElement = document.createElement('div');
        newElement.style.cssText = 'position:absolute;top:0px;left:0px;width:100%;';
        document.body.appendChild(newElement);
        setElement(newElement);
        return function () {
            if (newElement && newElement.parentNode) {
                newElement.parentNode.removeChild(newElement);
            }
        };
    }, []);
    React.useLayoutEffect(function () {
        var updateContainer = function () {
            if (containerRef && containerRef.current) {
                var data = containerRef.current.getBoundingClientRect();
                var newWidth = Math.ceil(data.width);
                var newTop = Math.ceil(data.top + data.height + window.pageYOffset);
                var newLeft = Math.ceil(data.left);
                setEnvironment({ width: newWidth, top: newTop, left: newLeft });
            }
        };
        updateContainer();
        window.addEventListener('resize', updateContainer);
        return function () { return window.removeEventListener('resize', updateContainer); };
    }, [containerRef]);
    var ref = useOutsideClick.useOutsideClick(hideDropDown);
    if (!element) {
        return null;
    }
    return ReactDOM__default['default'].createPortal(React__default['default'].createElement(DropdownWrapper, { "data-testid": "dropdown-options-" + name, style: { width: environment.width, top: environment.top, left: environment.left }, ref: ref },
        React__default['default'].createElement(Dropdown, { scrollable: optionLength > MIN_ITEM_SCROLLABLE }, children)), element);
};

var defaultComponents = {
    DropdownItem: DropdownBasicItem,
    DropdownLabel: DropdownBasicItem,
};
var FloatingLabelDropdown = function (_a) {
    var components = _a.components, name = _a.name, options = _a.options, value = _a.value, label = _a.label, className = _a.className, testId = _a.testId, onChange = _a.onChange, onBlur = _a.onBlur, onFocus = _a.onFocus, handleClick = _a.handleClick, isValid = _a.isValid, hint = _a.hint, customId = _a.id, disabled = _a.disabled, otherProps = tslib_es6.__rest(_a, ["components", "name", "options", "value", "label", "className", "testId", "onChange", "onBlur", "onFocus", "handleClick", "isValid", "hint", "id", "disabled"]);
    var id = customId || "select-id-" + name;
    var hintId = hint ? id + "_hint" : undefined;
    var nativeSelect = React.useRef(null);
    var describedBy = [otherProps['aria-describedby'], hintId].filter(function (e) { return !!e; }).join(' ');
    var UsedComponents = tslib_es6.__assign(tslib_es6.__assign({}, defaultComponents), components);
    var desktop = viewport_utils.isDesktop();
    var selectedItem = React.useMemo(function () { return options.find(function (x) { return x.value === value; }) || { label: label, value: '' }; }, [
        options,
        label,
        value,
    ]);
    var _b = React.useState(false), showDropDown = _b[0], setShowDropDown = _b[1];
    var toggleDropDown = function () {
        if (disabled) {
            return;
        }
        if (handleClick) {
            handleClick(!showDropDown);
        }
        if (options.length) {
            setShowDropDown(function (state) { return !state; });
        }
        else {
            setShowDropDown(false);
        }
    };
    var hideDropDown = function () {
        setShowDropDown(false);
    };
    var handleNativeSelect = function (e) {
        var selectedOption = options.find(function (x) { return x.value === e.target.value; });
        onChange(e, selectedOption);
    };
    var handleChange = function (option) { return function (e) {
        e.preventDefault();
        e.stopPropagation();
        if (!option.disabled && nativeSelect.current) {
            nativeSelect.current.value = option.value;
            var event_1 = { target: { name: name, value: option.value } };
            onChange(event_1, option);
            hideDropDown();
        }
    }; };
    var handleBlur = function (e) {
        if (onBlur) {
            onBlur(e);
        }
    };
    var preventNativeDropdown = function (e) {
        if (desktop) {
            e.preventDefault();
        }
    };
    var handleFocus = function (e) {
        if (onFocus) {
            onFocus(e);
        }
    };
    var inputBoxRef = React.useRef(null);
    var renderNativeSelect = function () {
        return options.length > 1 && (React__default['default'].createElement(StyledSelect, tslib_es6.__assign({ "aria-describedby": describedBy || undefined, id: id, value: selectedItem.value, name: name, onChange: handleNativeSelect, disabled: disabled, onMouseDown: preventNativeDropdown, onBlur: hideDropDown, ref: nativeSelect }, otherProps), options.map(function (option) { return (React__default['default'].createElement("option", { key: option.value, value: option.value, disabled: option.disabled }, option.label)); })));
    };
    var renderCustomDropdown = function () {
        return !!options.length &&
            showDropDown &&
            desktop && (React__default['default'].createElement(DropdownOptionList, { optionLength: options.length, containerRef: inputBoxRef, name: name, hideDropDown: hideDropDown }, options.map(function (option) { return (React__default['default'].createElement(UsedComponents.DropdownItem, tslib_es6.__assign({ role: "option", key: option.value, onClick: handleChange(option), selected: option.value === selectedItem.value }, option), option.label)); })));
    };
    return (React__default['default'].createElement(StyledWrapper, { className: className, "data-testid": testId, onMouseDown: desktop ? undefined : toggleDropDown, onClick: desktop ? toggleDropDown : undefined, isDisabled: disabled, onBlur: handleBlur, onFocus: handleFocus },
        React__default['default'].createElement(FloatingLabel_styles.StyledLabel, { htmlFor: id, isActive: !!selectedItem.value }, label),
        React__default['default'].createElement(StyledLabelContainer, { isEmpty: !selectedItem.value, "data-testid": "dropdown-fieldset", ref: inputBoxRef },
            React__default['default'].createElement(FloatingLabel_styles.StyledLegend, { isActive: !!selectedItem.value, "aria-hidden": "true" }, label),
            React__default['default'].createElement(FloatingLabel_styles.StyledTextFieldWrapper, null,
                selectedItem.value && (React__default['default'].createElement(UsedComponents.DropdownLabel, null, selectedItem.label)),
                options.length > 1 && (React__default['default'].createElement(Trigger, null,
                    React__default['default'].createElement(Icons_ArrowIcon_index['default'], { direction: showDropDown ? Icons_ArrowIcon_index.Direction.Up : Icons_ArrowIcon_index.Direction.Down, size: 8 }))),
                React__default['default'].createElement(StyledValidation, { isValid: isValid, "data-testid": "dropdown-validation" }),
                renderNativeSelect())),
        renderCustomDropdown(),
        hint && React__default['default'].createElement(FloatingLabel_styles.StyledHints, { id: hintId }, hint)));
};

exports.FloatingLabelDropdown = FloatingLabelDropdown;
//# sourceMappingURL=Dropdown-b622bab5.js.map
